﻿import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Chip,
  Grid,
  IconButton,
  Stack,
  Typography
} from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  FETCH_CLIENT_EQUIPMENT_INSPECTION_FORMS
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import NewEquipmentInspections from "./NewEquipmentInspections";

const sortArrayByDate = (arr) => {
  arr.sort((firstData, secondData) => {
    return Date.parse(secondData.date) - Date.parse(firstData.date);
  });
};

const formatDate = (dateStr) => {
  const date = moment(dateStr);
  const isCurrentYear = date.year() === moment().year();
  return isCurrentYear ? date.format("MMMM D") : date.format("YYYY-MM-DD");
};

export default function EquipmentInspections() {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);

  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state.main);
  const userId = loginData?.userInformation?.UserId;
  const [enspectionFromData, setEnspectionFormData] = useState([]);
  const LANGUAGE = ClientEnglishFallback.EquipmentInspections(
    multiLanguageData?.EquipmentInspections || {}
  );
  const {
    TEXT_NO_INSPECTION,
    TEXT_LOADING_INSPECTIONS,
    TEXT_NO_INSPECTIONS_TITLE,
    TEXT_LABEL_DATE,
    TEXT_LABEL_JOB,
    TEXT_LABEL_ASSET_CODE,
    TEXT_LABEL_EQUIPMENT_CODE,
    TEXT_STATUS_SUBMITTED,
    TEXT_STATUS_DRAFT,
    TEXT_NO_JOB_SELECTED
  } = LANGUAGE;

  const handleInspectionClick = (item) => {
    if (item?.isSubmitted) {
      return;
    }

    navigate(`${item.inspectionTypeId}`, {
      state: {
        inspectionRecord: item
      }
    });
  };

  useEffect(() => {
    fetchEquipmentInspectionsForms(1);
  }, [location]);

  const fetchEquipmentInspectionsForms = async (pageNumber) => {
    try {
      if (pageNumber === 1) {
        setIsLoading(true);
      }
      setAllDataLoaded(true);
      let obj = {
        PageNr: pageNumber,
        NrOfRecPerPage: 20,
        FullSearch: location?.state?.searchText || "",
        UserId: userId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            ClientEmployeeId: selectedClientData?.ClientEmployeeId
          }
        ],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };

      const response = await Postrequestcall(
        FETCH_CLIENT_EQUIPMENT_INSPECTION_FORMS,
        obj,
        loginData?.accessToken
      );
      if (response) {
        if (pageNumber > 1) {
          setEnspectionFormData((prevData) => prevData.concat(response?.data?.data));
        } else {
          sortArrayByDate(response?.data?.data);
          setEnspectionFormData(response?.data?.data || []);
        }

      }
    } catch (error) {
      console.log("fetchEquipmentInspectionsForms-> Error When Fetching Equipment Inspection Forms: ", error);
    } finally {
      setIsLoading(false);
      setAllDataLoaded(false);
    }
  };

  return (
    <>
      <Card
        sx={{
          boxShadow: "none",
          width: "100%",
          height: "100%",
          borderRadius: 3,
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(248,250,252,1) 100%)"
        }}>
        <CardContent sx={{ height: "100%", overflowY: "auto", scrollbarWidth: "none", p: 2 }}>
          {isLoading ? (
            <Box sx={{ textAlign: "center", py: 8 }}>
              <CircularProgress sx={{ color: selectedClientData?.AccentColor }} />
              <Typography variant="body2"  sx={{color: "text.secondary",  mt: 2 }}>
                {TEXT_LOADING_INSPECTIONS}
              </Typography>
            </Box>
          ) : enspectionFromData.length === 0 ? (
            <Box sx={{ textAlign: "center",  alignItems: "center",  justifyContent: "center",  display: "flex", border: "1px dashed #d9d9d9",
                borderRadius: 3,
                backgroundColor: "#fff",
                p: 3 }} id="scrollablediv_prodcut" height="70%">
              <Stack spacing={1} sx={{ alignItems: "center" }} maxWidth={360}>
                <Box
                  sx={{
                    width: 54,
                    height: 54,
                    borderRadius: "50%",
                    backgroundColor: "rgba(0,0,0,0.04)"
                  }}
                />
                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                  {TEXT_NO_INSPECTIONS_TITLE}
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary" }}>
                  {TEXT_NO_INSPECTION}
                </Typography>
              </Stack>
            </Box>
          ) : (
            <InfiniteScroll
              dataLength={enspectionFromData?.length}
              next={async () => {
                setPageNumber(pageNumber + 1);
                fetchEquipmentInspectionsForms(pageNumber + 1);
              }}
              height={"85vh"}
              style={{ scrollbarWidth: 'none' }}
              hasMore={true}
              loader={
                !allDataLoaded ? null : (
                  <h4 style={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress sx={{ color: selectedClientData?.AccentColor }} />
                  </h4>
                )
              }
            >
              <Grid container spacing={2} sx={{ rowGap: "12px", marginTop:'5px', flexDirection: "column" }}>
                {enspectionFromData.map((item, index) => (
                  <Grid key={index}>
                    <Box
                      sx={{
                        p: 2,
                        border: "1px solid",
                        borderColor: item?.isSubmitted ? "#d9ead3" : "#ffe0b2",
                        borderRadius: 3,
                        cursor: item?.isSubmitted ? "default" : "pointer",
                        backgroundColor: item?.isSubmitted ? "#fbfffb" : "#fffdf8",
                        transition: "transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease",
                        "&:hover": item?.isSubmitted
                          ? {}
                          : {
                              transform: "translateY(-1px)",
                              boxShadow: "0 8px 22px rgba(0,0,0,0.06)",
                              borderColor: selectedClientData?.AccentColor || "#ff9800"
                            }
                      }}
                      onClick={() => handleInspectionClick(item)}>
                      <Stack direction="row" sx={{ gap: 1.5,  justifyContent: "space-between"  }} >
                        <Box sx={{ minWidth: 0, flex: 1 }}>
                          <Typography sx={{ fontWeight: 500, lineHeight: 1.2 }} variant="subtitle1">
                            {item.inspectionTypeName}
                          </Typography>
                          <Box sx={{ mt: 1.1, display: "flex", flexDirection: "column", gap: 0.75 }}>
                            <Box sx={{ display: "flex", gap: 1, alignItems: "baseline" }}>
                              <Typography
                                variant="caption"
                                
                                sx={{color: "text.secondary",  minWidth: 42, lineHeight: 1.15 }}>
                                {TEXT_LABEL_JOB}
                              </Typography>
                              <Typography sx={{ color: "text.primary",  fontWeight: 600, lineHeight: 1.2 }} variant="body2">
                                {item.clientJobCode && item.clientJobName
                                  ? `${item.clientJobCode} - ${item.clientJobName}`
                                  : TEXT_NO_JOB_SELECTED}
                              </Typography>
                            </Box>
                            <Box sx={{ display: "flex", gap: 1, alignItems: "baseline" }}>
                              <Typography
                                variant="caption"
                                
                                sx={{color: "text.secondary",  minWidth: 82, lineHeight: 1.15 }}>
                                {item.fixedAssetId ? TEXT_LABEL_ASSET_CODE : TEXT_LABEL_EQUIPMENT_CODE}
                              </Typography>
                              <Typography sx={{ color: "text.primary",  fontWeight: 600, lineHeight: 1.2 }} variant="body2">
                                {item.fixedAssetId
                                  ? item.assetCode || "N/A"
                                  : item.equipmentCode || "N/A"}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                        <Box sx={{ textAlign: "right", flexShrink: 0 }}>
                          <Typography variant="caption"  sx={{color: "text.secondary",  display: "block", lineHeight: 1.15 }}>
                            {TEXT_LABEL_DATE}
                          </Typography>
                          <Typography sx={{ fontWeight: 700, color: "text.primary",  lineHeight: 1.2 }} variant="body2">
                            {formatDate(item.date)}
                          </Typography>
                          <Chip
                            size="small"
                            label={item?.isSubmitted ? TEXT_STATUS_SUBMITTED : TEXT_STATUS_DRAFT}
                            color={item?.isSubmitted ? "success" : "warning"}
                            variant="outlined"
                            sx={{ mt: 0.8, fontWeight: 700, height: 24, "& .MuiChip-label": { px: 1 } }}
                          />
                        </Box>
                      </Stack>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </InfiniteScroll>
          )}
        </CardContent>
      </Card>

      <div className="button-div">
        <IconButton
          className="icon-button"
          sx={{ backgroundColor: selectedClientData?.AccentColor }}
          onClick={() => {
            setOpen(true);
          }}>
          <AddIcon className="add-icon" />
        </IconButton>
      </div>

      {
        open && (
          <NewEquipmentInspections
            open={open}
            setOpen={setOpen}
          />
        )
      }
    </>
  );
}

